export default __webpack_public_path__ + "static/media/Hobbies.eacd734d.png";